import { Gamepad2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { EmptyState } from "@/components/ui/empty-state";

const EmptyGamesView = () => {
  const navigate = useNavigate();

  return (
    <EmptyState
      icon={Gamepad2}
      title="No active games yet"
      action={{ label: "Create Your First Game", onClick: () => navigate("/games") }}
    />
  );
};

export default EmptyGamesView;
